import React, {useEffect, useState} from "react";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {FormControl, Grid, MenuItem, Select} from "@mui/material";

const CustomDateFilter = (header, columnFilters, filterName) => {
    const [dateValue, setDateValue] = useState(null);
    const [operator, setOperator] = useState(null);

    useEffect(() => {
        const hasUpdatedAt = columnFilters.some(obj => {
            return obj.id.toLowerCase() === filterName
        });
        if (!hasUpdatedAt) {
            setDateValue(null);
            setOperator(null);
        } else {
            const filter = columnFilters.find(obj => obj.id.toLowerCase() === filterName.toLowerCase());
            if (filter && filter.value) {
                setDateValue(filter.value.date || null);
                setOperator(filter.value.operator || null);
            }
        }
    }, [columnFilters]);

    const handleDateChange = (newValue) => {
        setDateValue(newValue);
        if (operator !== null) {
            header.column.setFilterValue({operator: operator, date: newValue});
        }
    };
    const handleOperatorChange = (event) => {
        const newOperator = event.target.value;
        setOperator(newOperator);
        if (dateValue !== null) {
            header.column.setFilterValue({operator: newOperator, date: dateValue});
        }
    };

    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item xs={4}>
                <FormControl fullWidth size="small">
                    <Select
                        variant='standard'
                        sx={{height: '2rem', width: '4.0625rem'}}
                        value={operator}
                        onChange={handleOperatorChange}
                    >
                        <MenuItem value=">">{'>'}</MenuItem>
                        <MenuItem value=">=">{'>='}</MenuItem>
                        <MenuItem value="<">{'<'}</MenuItem>
                        <MenuItem value="<=">{'<='}</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={8}>
                <DatePicker
                    value={dateValue}
                    onChange={handleDateChange}
                    slotProps={{
                        textField: {
                            size: 'small', variant: 'standard', sx: {'.MuiInputBase-input': {fontSize: '0.8rem', padding: '0.031rem', border: 'none', height: '1.9rem'}}
                        }
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default CustomDateFilter
